import styled from 'styled-components';

const TextAndIconContainer = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S4};
`;

const IconButton = styled.button`
  padding: 0;
  color: ${({ theme }) => theme.colors.GREY_DARK};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`;

export { TextAndIconContainer, IconButton };
